import { useTranslation } from 'react-i18next';
import { UserCog } from 'lucide-react';
import { GuideSection } from '../components/GuideSection';
import { GuideSubSection } from '../components/GuideSubSection';

export function ProfileSection() {
  const { t } = useTranslation('help');
  const s = 'sections.profile';

  return (
    <GuideSection
      id="profile"
      title={t(`${s}.title`)}
      description={t(`${s}.description`)}
      icon={UserCog}
    >
      <GuideSubSection title={t(`${s}.changePassword.title`)}>
        <p>{t(`${s}.changePassword.p1`)}</p>
        <p>{t(`${s}.changePassword.p2`)}</p>
        <p className="text-xs text-slate-500 italic">{t(`${s}.changePassword.ssoNote`)}</p>
      </GuideSubSection>

      <GuideSubSection title={t(`${s}.twoFactorManagement.title`)}>
        <p>{t(`${s}.twoFactorManagement.p1`)}</p>
        <p>{t(`${s}.twoFactorManagement.p2`)}</p>
      </GuideSubSection>

      <GuideSubSection title={t(`${s}.notificationPrefs.title`)}>
        <p>{t(`${s}.notificationPrefs.p1`)}</p>
        <p>{t(`${s}.notificationPrefs.p2`)}</p>
      </GuideSubSection>

      <GuideSubSection title={t(`${s}.language.title`)}>
        <p>{t(`${s}.language.p1`)}</p>
        <p>{t(`${s}.language.p2`)}</p>
      </GuideSubSection>
    </GuideSection>
  );
}
